//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.nav`
    position: relative;
    margin: 10px 14px;
    border-bottom: 1px solid var(--light-blue-1);
`;
export const Tabs = styled.ul`
    display: flex;
    margin: 0;
    padding: 0;
`;
const defaultTabWidth = 160;
const changeTransitionValue = "0.4s";
export const Tab = styled.h3`
    font-size: 13px;
    color: var(--light-gray-5);
    width: ${({ tabWidth = defaultTabWidth }) => tabWidth}px;
    margin: 0;
    padding: 10px 0;
    text-align: center;
    transition: ${changeTransitionValue};
    user-select: none;
    cursor: pointer;
    &.current {
        color: var(--purple-2);
    }
    &.disabled {
        cursor: default;
        pointer-events: none;
        color: var(--light-gray-4);
        &.current {
            color: var(--purple-4);
        }
    }
`;
export const Cursor = styled.hr`
    position: absolute;
    bottom: -2px;
    margin: 0;
    left: ${({ currentTabIdx, width }) => currentTabIdx*width}px;
    width: ${({ width }) => width}px;
    height: 3px;
    background-color: var(--purple-2);
    border: 0;
    border-radius: 8px;
    transition: ${changeTransitionValue};
    &.disabled {
        background-color: var(--purple-4);
    }
`;